module.exports = __webpack_public_path__ + "img/bocom.e5152155.png";